<template>
    <b-row v-if="Object.keys(paginacao).length">
        <b-col sm="6" class="text-center text-md-left">
            Mostrando {{ paginacao.start }} a 
            {{ paginacao.end }} de um total de 
            {{ paginacao.count }}
        </b-col>
        <b-col v-if="paginacao.pageCount > 1" sm="6" class="d-flex justify-content-center justify-content-md-end">
            <b-pagination
                v-model="paginacao.page"
                :total-rows="paginacao.count"
                :currentPage="paginacao.page" 
                :per-page="paginacao.limit"
                align="right"
                @change="alteraPaginacao"
            ></b-pagination>
        </b-col>
    </b-row>
</template>
<script>
export default {
    data(){
        return {
            paginacao: {}
        }
    },
    mounted() {
        this.paginacao = this.$parent.$parent.paginacao
    },
    watch: {
        '$parent.$parent.paginacao'(paginacao){
            this.paginacao = paginacao
        }
    },
    methods: {
        alteraPaginacao(pagina){
            const filtros = {
                page: pagina
            }
            this.$parent.$parent.atualizaUrl(filtros)
        }
    },
}
</script>
<style lang="scss" scoped>
.centered ul{
    justify-content: center !important;
    margin-top: 15px;
}
</style>